import { ECommonValue, EInputType, IInputField } from "../../ui/Input/Input";

export enum EHeaderLinkInputs {
  text = "text",
  link = "link",
  isVisible = "isVisible",
}

export const getHeaderLinkInputs = (showLabels: boolean = true): IInputField => ({
  [EHeaderLinkInputs.text]: {
    type: EInputType.text,
    label: showLabels ? "Text" : undefined,
    value: "",
    validation: { required: true },
  },
  [EHeaderLinkInputs.link]: {
    type: EInputType.text,
    label: showLabels ? "Link (optional)" : undefined,
    value: "",
  },
  [EHeaderLinkInputs.isVisible]: {
    type: EInputType.checkbox,
    label: showLabels ? "Visible" : undefined,
    value: [ECommonValue.YES],
    options: [{ value: ECommonValue.YES, label: showLabels ? "Visible" : "" }],
  },
});

export const formatHeaderLinkForInput = (link?: any) => {
  if (!link) return undefined;
  return {
    ...link,
    isVisible: link.isVisible ? [ECommonValue.YES] : [],
  };
};

export const formatHeaderLinkForSubmit = (data: any) => {
  return {
    ...data,
    isVisible: !!(data.isVisible && data.isVisible.indexOf(ECommonValue.YES) !== -1),
  };
};
